import { LinkDetailInsert, LinkDetailDelete, LinkDetailUpdate, LinkDetailGetById, LinkDetailGetList, LinkDetailGetPageList } from "@/api/linkdetail/index.js";

const state = {

}

const getters = {

}

const mutations = {

}

const actions = {
    // 新增
    LinkDetailInsert(context, payload) {
        return new Promise((resolve, reject) => {
            
            
            LinkDetailInsert({ ...payload }).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 更新
    LinkDetailUpdate(context, payload) {
        let { id } = payload
        return new Promise((resolve, reject) => {
            LinkDetailUpdate(id, { ...payload }).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取
    LinkDetailGetById(context, payload) {
        let { id } = payload
        return new Promise((resolve, reject) => {
            LinkDetailGetById(id).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取列表
    LinkDetailGetList(context, payload) {
        return new Promise((resolve, reject) => {
            let params = { ...payload }
            LinkDetailGetList(params).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取分页列表
    LinkDetailGetPageList(context, payload) {
        return new Promise((resolve, reject) => {
            let params = { ...payload }
            LinkDetailGetPageList(params).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}